import { Clock, FileText } from 'lucide-react'
import type { ConfigSubTab } from '../hooks/useAttendanceSettings'

interface ConfigurationSubTabsProps {
  activeSubTab: ConfigSubTab
  onSubTabChange: (tab: ConfigSubTab) => void
}

export function ConfigurationSubTabs({
  activeSubTab,
  onSubTabChange,
}: ConfigurationSubTabsProps) {
  return (
    <div className="w-full rounded-xl bg-gray-100 p-1 flex items-center gap-1">
      <button
        type="button"
        onClick={() => onSubTabChange('attendance-settings')}
        className={`flex-1 flex items-center justify-center gap-2 py-2.5 px-4 rounded-lg text-sm font-semibold transition-all cursor-pointer ${
          activeSubTab === 'attendance-settings'
            ? 'bg-white shadow-sm text-gray-900 font-semibold'
            : 'bg-transparent text-gray-500 hover:text-gray-700'
        }`}
      >
        <Clock className="h-4 w-4" />
        <span>Attendance Settings</span>
      </button>

      <button
        type="button"
        onClick={() => onSubTabChange('leave-policies')}
        className={`flex-1 flex items-center justify-center gap-2 py-2.5 px-4 rounded-lg text-sm font-semibold transition-all cursor-pointer ${
          activeSubTab === 'leave-policies'
            ? 'bg-white shadow-sm text-gray-900 font-semibold'
            : 'bg-transparent text-gray-500 hover:text-gray-700'
        }`}
      >
        <FileText className="h-4 w-4" />
        <span>Leave Policies</span>
      </button>
    </div>
  )
}
